//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 将整数转换成 时：分：秒的格式
function realFormatSecond(second) {
  var secondType = typeof second;

  if (secondType === "number" || secondType === "string") {
    second = parseInt(second);

    var hours = Math.floor(second / 3600);
    second = second - hours * 3600;
    var mimute = Math.floor(second / 60);
    second = second - mimute * 60;

    // ${hours}

    return `${("0" + mimute).slice(-2)}'${("0" + second).slice(-2)}''`;
  } else {
    return `00'00''`;
  }
}

export default {
  name: "MiniPlayer",
  props: {
    src: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      audio: {
        source: this.src,
        playing: false,
        currentTime: 0,
        maxTime: 0
      }
    };
  },

  computed: {
    isAudioUrlEmpty() {
      return this.src === "";
    }
  },

  methods: {
    startPlayOrPause() {
      return this.audio.playing ? this.pause() : this.play();
    },
    onPause() {
      this.audio.playing = false;
      this.$emit("on-pause", this.audio); // 向父组件传递
    },

    onPlay() {
      this.audio.playing = true;
      this.$emit("on-play", this.audio); // 向父组件传递
    },

    control() {
      if (this.audio.playing) {
        this.pause();
      } else {
        this.play();
      }
      this.audio.playing = !this.audio.playing;
    },

    play() {
      this.$refs.audio.play();
    },

    pause() {
      this.$refs.audio.pause();
    },

    changeCurrentTime(index) {},

    // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
    onTimeupdate(res) {
      this.audio.currentTime = res.target.currentTime;
      this.audio.sliderTime = parseInt(
        (this.audio.currentTime / this.audio.maxTime) * 100
      );
    },

    // 当加载语音流元数据完成后，会触发该事件的回调函数
    // 语音元数据主要是语音的长度之类的数据
    onLoadedmetadata(res) {
      this.audio.maxTime = parseInt(res.target.duration);
    }
  },
  filters: {
    // 使用组件过滤器来动态改变按钮的显示
    transPlayPause(value) {
      return value ? "暂停" : "播放";
    },
    // 将整数转化成时分秒
    formatSecond(second = 0) {
      return realFormatSecond(second);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/music_player/MiniPlayer.vue